/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Conversation_WordsInputs */

const en_us2_search_conversation_words = /** @type {(inputs: Search_Conversation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`conversation trainer chat`)
};

const pt_br2_search_conversation_words = /** @type {(inputs: Search_Conversation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`conversa personal chat`)
};

const es_419_search_conversation_words = /** @type {(inputs: Search_Conversation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`conversacion entrenador chat`)
};

const pt_pt2_search_conversation_words = /** @type {(inputs: Search_Conversation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`conversa treinador chat`)
};

const fr_fr2_search_conversation_words = /** @type {(inputs: Search_Conversation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`conversation coach chat discussion`)
};

const de_de2_search_conversation_words = /** @type {(inputs: Search_Conversation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unterhaltung coach chat trainer`)
};

const it_it2_search_conversation_words = /** @type {(inputs: Search_Conversation_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`conversazione coach chat`)
};

/**
* | output |
* | --- |
* | "conversation trainer chat" |
*
* @param {Search_Conversation_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_conversation_words = /** @type {((inputs?: Search_Conversation_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Conversation_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_conversation_words(inputs)
	if (locale === "es-419") return es_419_search_conversation_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_conversation_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_conversation_words(inputs)
	if (locale === "de-DE") return de_de2_search_conversation_words(inputs)
	if (locale === "it-IT") return it_it2_search_conversation_words(inputs)
	return en_us2_search_conversation_words(inputs)
});
export { search_conversation_words as "search.conversation_words" }